import { render, staticRenderFns } from "./BasketDot.vue?vue&type=template&id=d3f4da08&"
import script from "./BasketDot.vue?vue&type=script&lang=js&"
export * from "./BasketDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports